"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "laghi": {
    "e97422af": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "berta": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f31be75": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "bragioli": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "56d3224e": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "chezzi": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a9360ad0": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-molini": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1b0ebeee": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "cruzzi": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dd6b0bf8": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "galgara": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c54559e5": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "laita": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5447612e": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "lorenzi": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "530f371f": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "lunardelli": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc06c2fd": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "marogne": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cb7cf822": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "menara": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5281a845": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "ossati": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c86a0ee": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "peterlini": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8272f5d5": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "roteche": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "117fdf4e": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "silvestri": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d18b7cf8": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "tretti": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff089340": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "vanzi": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fcb3df24": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "skipSearch": false
    }],
    "zanconi": [{
      "hkey": "f33a0a7d",
      "slug": "laghi",
      "name": "Laghi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;